import usePnlModalCardImagePaths from 'src/components/Modals/PnlModal/hooks/usePnlModalCardImagePaths';
import { PnlModalVariant } from 'src/components/Modals/PnlModal/types';

interface Props {
	backgroundImagePathIndex: number;
	marketIndex?: number;
	variant: PnlModalVariant;
}

export default function PnlModalPaginationDisplay({
	backgroundImagePathIndex,
	marketIndex,
	variant,
}: Props) {
	const backgroundImagePaths = usePnlModalCardImagePaths({
		marketIndex,
		variant,
	});

	if (backgroundImagePaths.length === 1) {
		return null;
	}

	return (
		<span className="typo-body-sm">
			{backgroundImagePathIndex + 1}
			<span className="text-text-secondary">
				/{backgroundImagePaths.length}
			</span>
		</span>
	);
}
